import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import Actions from './actions';
import { errorDuck } from '../error';
import * as UTIL from '../../util';
import { apiUtil } from '../../util';
import { bonusRewardsResponse, customRewardsRedemptionResponse, getOrderPegPointsResponse, getProductPointsResponse, pegPointsModuleResponse, rewardsRedemptionResponse } from './mockResponses';
import moment from 'moment';
import { getSessionStorageKey } from '../../util/sessionStorage';
var Creators = Actions.Creators;
var getPegPointsAction = Creators.getPegPointsAction;
var resetPegPointsAction = Creators.resetPegPointsAction;
var getRewardsRedemptionAction = Creators.getRewardsRedemptionAction;
var getCustomRewardsRedemptionAction = Creators.getCustomRewardsRedemptionAction;
var redeemRewardsAction = Creators.redeemRewardsAction;
var resetRewardsRedemptionAction = Creators.resetRewardsRedemptionAction;
var resetRewardsRedemptionModule = Creators.resetRewardsRedemptionModule;
var storeLastCustomRewardsRequest = Creators.storeLastCustomRewardsRequest;
var storeLastRemovedItem = Creators.storeLastRemovedItem;
var processingRewards = Creators.processingRewards;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;

function getRewardsAndCoupons(state) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _state$account, _state$account$aadRes, _state$account$aadRes2, _state$account$aadRes3, _state$account2, _state$account2$aadRe, _state$account2$aadRe2, _state$account2$aadRe3, _state$account3, _state$account3$aadRe;

      var email, token, processResponse, url;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Getting storage form session since there is an issue when multiple components are using the same redux store
              email = ((_state$account = state.account) === null || _state$account === void 0 ? void 0 : (_state$account$aadRes = _state$account.aadResponse) === null || _state$account$aadRes === void 0 ? void 0 : (_state$account$aadRes2 = _state$account$aadRes.account) === null || _state$account$aadRes2 === void 0 ? void 0 : (_state$account$aadRes3 = _state$account$aadRes2.idToken) === null || _state$account$aadRes3 === void 0 ? void 0 : _state$account$aadRes3.email) || ((_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : (_state$account2$aadRe = _state$account2.aadResponse) === null || _state$account2$aadRe === void 0 ? void 0 : (_state$account2$aadRe2 = _state$account2$aadRe.account) === null || _state$account2$aadRe2 === void 0 ? void 0 : (_state$account2$aadRe3 = _state$account2$aadRe2.idToken) === null || _state$account2$aadRe3 === void 0 ? void 0 : _state$account2$aadRe3.signInName);
              token = (_state$account3 = state.account) === null || _state$account3 === void 0 ? void 0 : (_state$account3$aadRe = _state$account3.aadResponse) === null || _state$account3$aadRe === void 0 ? void 0 : _state$account3$aadRe.jwtIdToken;

              processResponse = function processResponse(res) {
                var _res$loyalty, _res$loyalty$customer, _res$loyalty$customer2, _res$loyalty$customer3, _res$loyalty2, _res$loyalty2$custome, _res$loyalty2$custome2, _res$loyalty2$custome3;

                var coupons = (_res$loyalty = res.loyalty) === null || _res$loyalty === void 0 ? void 0 : (_res$loyalty$customer = _res$loyalty.customers) === null || _res$loyalty$customer === void 0 ? void 0 : (_res$loyalty$customer2 = _res$loyalty$customer.customerCoupons) === null || _res$loyalty$customer2 === void 0 ? void 0 : (_res$loyalty$customer3 = _res$loyalty$customer2.filter(function (coupon) {
                  return coupon.status === 'redeemed';
                })) === null || _res$loyalty$customer3 === void 0 ? void 0 : _res$loyalty$customer3.map(function (coupon) {
                  return {
                    code: coupon.code,
                    external_id: coupon.reward.externalId
                  };
                });
                var pegRewards = (_res$loyalty2 = res.loyalty) === null || _res$loyalty2 === void 0 ? void 0 : (_res$loyalty2$custome = _res$loyalty2.customers) === null || _res$loyalty2$custome === void 0 ? void 0 : (_res$loyalty2$custome2 = _res$loyalty2$custome.customerRewards) === null || _res$loyalty2$custome2 === void 0 ? void 0 : (_res$loyalty2$custome3 = _res$loyalty2$custome2.filter(function (reward) {
                  return reward.points > 0;
                })) === null || _res$loyalty2$custome3 === void 0 ? void 0 : _res$loyalty2$custome3.map(function (reward) {
                  return {
                    id: reward.id,
                    points: reward.points
                  };
                });
                return {
                  coupons: coupons,
                  pegRewards: pegRewards
                };
              }; // storybook mock


              if (!(window.location.href.indexOf("localhost:9009") > -1)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", Promise.resolve(processResponse(bonusRewardsResponse) || {}));

            case 5:
              if (email) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", Promise.resolve([]));

            case 7:
              url = apiUtil.API.loyalty.getRewardsAndCoupons.replace('{email}', email);
              return _context.abrupt("return", UTIL.apiUtil.fetchGet(url, token).then(function (res) {
                if (res) {
                  return processResponse(res) || {};
                } else {
                  return [];
                }
              }).catch(function (err) {
                console.error("Error on Rewards and Coupons request: ", err);
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function getPegPoints(state) {
  var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var _sessionState$aadResp;

      var sessionState, token, url;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(window.location.href.indexOf("localhost:9009") > -1)) {
                _context2.next = 3;
                break;
              }

              dispatch(getPegPointsAction("300"));
              return _context2.abrupt("return", "300");

            case 3:
              // Getting storage form session since there is an issue when multiple components are using the same redux store
              sessionState = getSessionStorageKey("account");
              token = sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp = sessionState.aadResponse) === null || _sessionState$aadResp === void 0 ? void 0 : _sessionState$aadResp.jwtIdToken;

              if (token) {
                _context2.next = 8;
                break;
              }

              dispatch(getPegPointsAction("0"));
              return _context2.abrupt("return", "0");

            case 8:
              if (!email) {
                email = sessionState.aadResponse.account.idToken.email || sessionState.aadResponse.account.idToken.signInName;
              }

              url = apiUtil.API.loyalty.getPegPoints.replace("{email}", email);
              return _context2.abrupt("return", UTIL.apiUtil.fetchGet(url, token).then(function (res) {
                if (res) {
                  var _res$loyalty3, _res$loyalty3$custome, _res$loyalty4, _res$loyalty4$custome, _res$loyalty5, _res$loyalty5$custome, _res$loyalty6, _res$loyalty6$custome;

                  dispatch(getPegPointsAction(((_res$loyalty3 = res.loyalty) === null || _res$loyalty3 === void 0 ? void 0 : (_res$loyalty3$custome = _res$loyalty3.customers) === null || _res$loyalty3$custome === void 0 ? void 0 : _res$loyalty3$custome.balance) ? String((_res$loyalty4 = res.loyalty) === null || _res$loyalty4 === void 0 ? void 0 : (_res$loyalty4$custome = _res$loyalty4.customers) === null || _res$loyalty4$custome === void 0 ? void 0 : _res$loyalty4$custome.balance) : "0"));
                  return ((_res$loyalty5 = res.loyalty) === null || _res$loyalty5 === void 0 ? void 0 : (_res$loyalty5$custome = _res$loyalty5.customers) === null || _res$loyalty5$custome === void 0 ? void 0 : _res$loyalty5$custome.balance) ? String((_res$loyalty6 = res.loyalty) === null || _res$loyalty6 === void 0 ? void 0 : (_res$loyalty6$custome = _res$loyalty6.customers) === null || _res$loyalty6$custome === void 0 ? void 0 : _res$loyalty6$custome.balance) : "0";
                }
              }).catch(function (err) {
                console.error("Error on Peg Points request: ", err);
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function setLocalPegPoints(state, points) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(getPegPointsAction(points ? String(points) : "0"));
              return _context3.abrupt("return", points ? String(points) : "0");

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function resetPegPoints(state) {
  return function (dispatch) {
    dispatch(resetPegPointsAction('0'));
    return '0';
  };
}

function getExpirationDate(date) {
  var expiration = null;

  if (date) {
    if (date.indexOf('T') > -1) {
      expiration = moment(date.split('T')[0]).format('MM/DD/YY');
    } else {
      expiration = moment(date).format('MM/DD/YY');
    }
  }

  return expiration;
}

function getBonusRewards(state) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var _sessionState$aadResp2, _sessionState$aadResp3, _sessionState$aadResp4, _sessionState$aadResp5, _sessionState$aadResp6, _sessionState$aadResp7, _sessionState$aadResp8;

      var sessionState, email, token, _res$loyalty7, _res$loyalty7$custome, res, result, url;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // Getting storage form session since there is an issue when multiple components are using the same redux store
              sessionState = getSessionStorageKey('account');
              email = (sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp2 = sessionState.aadResponse) === null || _sessionState$aadResp2 === void 0 ? void 0 : (_sessionState$aadResp3 = _sessionState$aadResp2.account) === null || _sessionState$aadResp3 === void 0 ? void 0 : (_sessionState$aadResp4 = _sessionState$aadResp3.idToken) === null || _sessionState$aadResp4 === void 0 ? void 0 : _sessionState$aadResp4.email) || (sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp5 = sessionState.aadResponse) === null || _sessionState$aadResp5 === void 0 ? void 0 : (_sessionState$aadResp6 = _sessionState$aadResp5.account) === null || _sessionState$aadResp6 === void 0 ? void 0 : (_sessionState$aadResp7 = _sessionState$aadResp6.idToken) === null || _sessionState$aadResp7 === void 0 ? void 0 : _sessionState$aadResp7.signInName);
              token = sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp8 = sessionState.aadResponse) === null || _sessionState$aadResp8 === void 0 ? void 0 : _sessionState$aadResp8.jwtIdToken; // storybook mock

              if (!(window.location.href.indexOf('localhost:9009') > -1)) {
                _context4.next = 7;
                break;
              }

              res = bonusRewardsResponse;
              result = (_res$loyalty7 = res.loyalty) === null || _res$loyalty7 === void 0 ? void 0 : (_res$loyalty7$custome = _res$loyalty7.customers) === null || _res$loyalty7$custome === void 0 ? void 0 : _res$loyalty7$custome.customerCoupons.map(function (coupon) {
                var _ref5 = coupon !== null && coupon !== void 0 ? coupon : {},
                    reward = _ref5.reward;

                if (reward && coupon.status === 'redeemed') {
                  var _reward$offerMetadata, _reward$offerMetadata2;

                  var expiration = getExpirationDate(coupon === null || coupon === void 0 ? void 0 : coupon.expiresAt);
                  return {
                    fields: {
                      Id: {
                        value: reward === null || reward === void 0 ? void 0 : reward.rewardsId
                      },
                      Code: {
                        value: coupon === null || coupon === void 0 ? void 0 : coupon.code
                      },
                      Image: {
                        value: {
                          src: (reward === null || reward === void 0 ? void 0 : reward.imageUrl) || '',
                          alt: (reward === null || reward === void 0 ? void 0 : reward.name) || '',
                          title: (reward === null || reward === void 0 ? void 0 : reward.name) || ''
                        }
                      },
                      Name: {
                        value: (reward === null || reward === void 0 ? void 0 : reward.name) || ''
                      },
                      DisplayName: {
                        value: (reward === null || reward === void 0 ? void 0 : reward.displayName) || ''
                      },
                      Description: {
                        value: (reward === null || reward === void 0 ? void 0 : reward.description) || ''
                      },
                      Expiration: {
                        value: expiration !== null && expiration !== void 0 ? expiration : null
                      },
                      MenuTag: {
                        value: (reward === null || reward === void 0 ? void 0 : (_reward$offerMetadata = reward.offerMetadata) === null || _reward$offerMetadata === void 0 ? void 0 : (_reward$offerMetadata2 = _reward$offerMetadata.menuTag) === null || _reward$offerMetadata2 === void 0 ? void 0 : _reward$offerMetadata2[0]) || 'N/A'
                      },
                      ExternalId: {
                        value: (reward === null || reward === void 0 ? void 0 : reward.externalId) || null
                      }
                    }
                  };
                }

                return null;
              }).filter(Boolean);
              return _context4.abrupt("return", Promise.resolve(result || []));

            case 7:
              if (email) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return", Promise.resolve([]));

            case 9:
              url = apiUtil.API.loyalty.getBonusRewards.replace('{email}', email);
              return _context4.abrupt("return", UTIL.apiUtil.fetchGet(url, token).then(function (res) {
                if (res) {
                  var _res$loyalty8, _res$loyalty8$custome;

                  var _result = (_res$loyalty8 = res.loyalty) === null || _res$loyalty8 === void 0 ? void 0 : (_res$loyalty8$custome = _res$loyalty8.customers) === null || _res$loyalty8$custome === void 0 ? void 0 : _res$loyalty8$custome.customerCoupons.map(function (coupon) {
                    var _ref6 = coupon !== null && coupon !== void 0 ? coupon : {},
                        reward = _ref6.reward;

                    if (reward && coupon.status === 'redeemed') {
                      var _reward$offerMetadata3, _reward$offerMetadata4;

                      var expiration = getExpirationDate(coupon === null || coupon === void 0 ? void 0 : coupon.expiresAt);
                      return {
                        fields: {
                          Id: {
                            value: reward === null || reward === void 0 ? void 0 : reward.rewardsId
                          },
                          Code: {
                            value: coupon === null || coupon === void 0 ? void 0 : coupon.code
                          },
                          Image: {
                            value: {
                              src: (reward === null || reward === void 0 ? void 0 : reward.imageUrl) || '',
                              alt: (reward === null || reward === void 0 ? void 0 : reward.name) || '',
                              title: (reward === null || reward === void 0 ? void 0 : reward.name) || ''
                            }
                          },
                          Name: {
                            value: (reward === null || reward === void 0 ? void 0 : reward.name) || ''
                          },
                          DisplayName: {
                            value: (reward === null || reward === void 0 ? void 0 : reward.displayName) || ''
                          },
                          Description: {
                            value: (reward === null || reward === void 0 ? void 0 : reward.description) || ''
                          },
                          Expiration: {
                            value: expiration !== null && expiration !== void 0 ? expiration : null
                          },
                          MenuTag: {
                            value: (reward === null || reward === void 0 ? void 0 : (_reward$offerMetadata3 = reward.offerMetadata) === null || _reward$offerMetadata3 === void 0 ? void 0 : (_reward$offerMetadata4 = _reward$offerMetadata3.menuTag) === null || _reward$offerMetadata4 === void 0 ? void 0 : _reward$offerMetadata4[0]) || 'N/A'
                          },
                          ExternalId: {
                            value: (reward === null || reward === void 0 ? void 0 : reward.externalId) || null
                          }
                        }
                      };
                    }

                    return null;
                  }).filter(Boolean);

                  return _result || [];
                } else {
                  return [];
                }
              }).catch(function (err) {
                console.error('Error on Rewards request: ', err);
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function getBonusRewardsAccountInfo(state, accountInfo) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var _accountInfo$account, _accountInfo$account$, _accountInfo$account2, _accountInfo$account3;

      var email, token, _res$loyalty9, _res$loyalty9$custome, res, result, url;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              email = (accountInfo === null || accountInfo === void 0 ? void 0 : (_accountInfo$account = accountInfo.account) === null || _accountInfo$account === void 0 ? void 0 : (_accountInfo$account$ = _accountInfo$account.idToken) === null || _accountInfo$account$ === void 0 ? void 0 : _accountInfo$account$.email) || (accountInfo === null || accountInfo === void 0 ? void 0 : (_accountInfo$account2 = accountInfo.account) === null || _accountInfo$account2 === void 0 ? void 0 : (_accountInfo$account3 = _accountInfo$account2.idToken) === null || _accountInfo$account3 === void 0 ? void 0 : _accountInfo$account3.signInName);
              token = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.jwtIdToken; // storybook mock

              if (!(window.location.href.indexOf('localhost:9009') > -1)) {
                _context5.next = 6;
                break;
              }

              res = bonusRewardsResponse;
              result = (_res$loyalty9 = res.loyalty) === null || _res$loyalty9 === void 0 ? void 0 : (_res$loyalty9$custome = _res$loyalty9.customers) === null || _res$loyalty9$custome === void 0 ? void 0 : _res$loyalty9$custome.customerCoupons.map(function (coupon) {
                var _ref8 = coupon !== null && coupon !== void 0 ? coupon : {},
                    reward = _ref8.reward;

                if (reward && coupon.status === 'redeemed') {
                  var _reward$offerMetadata5, _reward$offerMetadata6;

                  var expiration = getExpirationDate(coupon === null || coupon === void 0 ? void 0 : coupon.expiresAt);
                  return {
                    fields: {
                      Id: {
                        value: reward === null || reward === void 0 ? void 0 : reward.rewardsId
                      },
                      Code: {
                        value: coupon === null || coupon === void 0 ? void 0 : coupon.code
                      },
                      Image: {
                        value: {
                          src: (reward === null || reward === void 0 ? void 0 : reward.imageUrl) || '',
                          alt: (reward === null || reward === void 0 ? void 0 : reward.name) || '',
                          title: (reward === null || reward === void 0 ? void 0 : reward.name) || ''
                        }
                      },
                      Name: {
                        value: (reward === null || reward === void 0 ? void 0 : reward.name) || ''
                      },
                      DisplayName: {
                        value: (reward === null || reward === void 0 ? void 0 : reward.displayName) || ''
                      },
                      Description: {
                        value: (reward === null || reward === void 0 ? void 0 : reward.description) || ''
                      },
                      Expiration: {
                        value: expiration !== null && expiration !== void 0 ? expiration : null
                      },
                      MenuTag: {
                        value: (reward === null || reward === void 0 ? void 0 : (_reward$offerMetadata5 = reward.offerMetadata) === null || _reward$offerMetadata5 === void 0 ? void 0 : (_reward$offerMetadata6 = _reward$offerMetadata5.menuTag) === null || _reward$offerMetadata6 === void 0 ? void 0 : _reward$offerMetadata6[0]) || 'N/A'
                      },
                      ExternalId: {
                        value: (reward === null || reward === void 0 ? void 0 : reward.externalId) || null
                      }
                    }
                  };
                }

                return null;
              }).filter(Boolean);
              return _context5.abrupt("return", Promise.resolve(result || []));

            case 6:
              if (email) {
                _context5.next = 8;
                break;
              }

              return _context5.abrupt("return", Promise.resolve([]));

            case 8:
              url = apiUtil.API.loyalty.getBonusRewards.replace('{email}', email);
              return _context5.abrupt("return", UTIL.apiUtil.fetchGet(url, token).then(function (res) {
                if (res) {
                  var _res$loyalty10, _res$loyalty10$custom;

                  var _result2 = (_res$loyalty10 = res.loyalty) === null || _res$loyalty10 === void 0 ? void 0 : (_res$loyalty10$custom = _res$loyalty10.customers) === null || _res$loyalty10$custom === void 0 ? void 0 : _res$loyalty10$custom.customerCoupons.map(function (coupon) {
                    var _ref9 = coupon !== null && coupon !== void 0 ? coupon : {},
                        reward = _ref9.reward;

                    if (reward && coupon.status === 'redeemed') {
                      var _reward$offerMetadata7, _reward$offerMetadata8;

                      var expiration = getExpirationDate(coupon === null || coupon === void 0 ? void 0 : coupon.expiresAt);
                      return {
                        fields: {
                          Id: {
                            value: reward === null || reward === void 0 ? void 0 : reward.rewardsId
                          },
                          Code: {
                            value: coupon === null || coupon === void 0 ? void 0 : coupon.code
                          },
                          Image: {
                            value: {
                              src: (reward === null || reward === void 0 ? void 0 : reward.imageUrl) || '',
                              alt: (reward === null || reward === void 0 ? void 0 : reward.name) || '',
                              title: (reward === null || reward === void 0 ? void 0 : reward.name) || ''
                            }
                          },
                          Name: {
                            value: (reward === null || reward === void 0 ? void 0 : reward.name) || ''
                          },
                          DisplayName: {
                            value: (reward === null || reward === void 0 ? void 0 : reward.displayName) || ''
                          },
                          Description: {
                            value: (reward === null || reward === void 0 ? void 0 : reward.description) || ''
                          },
                          Expiration: {
                            value: expiration !== null && expiration !== void 0 ? expiration : null
                          },
                          MenuTag: {
                            value: (reward === null || reward === void 0 ? void 0 : (_reward$offerMetadata7 = reward.offerMetadata) === null || _reward$offerMetadata7 === void 0 ? void 0 : (_reward$offerMetadata8 = _reward$offerMetadata7.menuTag) === null || _reward$offerMetadata8 === void 0 ? void 0 : _reward$offerMetadata8[0]) || 'N/A'
                          },
                          ExternalId: {
                            value: (reward === null || reward === void 0 ? void 0 : reward.externalId) || null
                          }
                        }
                      };
                    }

                    return null;
                  }).filter(Boolean);

                  return _result2 || [];
                } else {
                  return [];
                }
              }).catch(function (err) {
                console.error('Error on Rewards request: ', err);
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref7.apply(this, arguments);
    };
  }();
}

function getMenuItemPegPoints(state, productIds) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var _sessionState$aadResp9;

      var sessionState, token, result, url;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              // Getting storage form session since there is an issue when multiple components are using the same redux store
              sessionState = getSessionStorageKey('account');
              token = sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp9 = sessionState.aadResponse) === null || _sessionState$aadResp9 === void 0 ? void 0 : _sessionState$aadResp9.jwtIdToken; // storybook mock

              if (!(window.location.href.indexOf('localhost:9009') > -1)) {
                _context6.next = 5;
                break;
              }

              result = getProductPointsResponse;
              return _context6.abrupt("return", Promise.resolve(result || []));

            case 5:
              if (token) {
                _context6.next = 7;
                break;
              }

              return _context6.abrupt("return", Promise.resolve([]));

            case 7:
              url = apiUtil.API.loyalty.getMenuItemPegPoints.replace('{productChainId}', productIds);
              return _context6.abrupt("return", UTIL.apiUtil.fetchGet(url, token).then(function (res) {
                return res || [];
              }).catch(function (err) {
                console.error('Error on Menu Item Peg Amount request: ', err);
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref10.apply(this, arguments);
    };
  }();
}

function getPegPointsModule(state, data) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      var _sessionState$aadResp10;

      var sessionState, url, token, _res$loyalty11, _res$loyalty11$custom, res, result;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              // Getting storage form session since there is an issue when multiple components are using the same redux store
              sessionState = getSessionStorageKey("account");
              url = apiUtil.API.loyalty.getPegPointsModule;
              token = sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp10 = sessionState.aadResponse) === null || _sessionState$aadResp10 === void 0 ? void 0 : _sessionState$aadResp10.jwtIdToken; // storybook mock

              if (!(window.location.href.indexOf("localhost:9009") > -1)) {
                _context7.next = 7;
                break;
              }

              res = pegPointsModuleResponse;
              result = (_res$loyalty11 = res.loyalty) === null || _res$loyalty11 === void 0 ? void 0 : (_res$loyalty11$custom = _res$loyalty11.customers) === null || _res$loyalty11$custom === void 0 ? void 0 : _res$loyalty11$custom.points;
              return _context7.abrupt("return", Promise.resolve(result || 0));

            case 7:
              return _context7.abrupt("return", UTIL.apiUtil.fetchPost(url, data, token).then(function (res) {
                if (res) {
                  var _res$loyalty12, _res$loyalty12$custom;

                  var _result3 = res === null || res === void 0 ? void 0 : (_res$loyalty12 = res.loyalty) === null || _res$loyalty12 === void 0 ? void 0 : (_res$loyalty12$custom = _res$loyalty12.customers) === null || _res$loyalty12$custom === void 0 ? void 0 : _res$loyalty12$custom.points;

                  return _result3 || 0;
                } else {
                  return 0;
                }
              }).catch(function (err) {
                console.error("Error on Peg Points Module request: ", err);
                dispatch(receiveError(UTIL.buildError(err)));
                return 0;
              }));

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref11.apply(this, arguments);
    };
  }();
}

function getPegPointsModuleAuth(state, data) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch) {
      var _sessionState$aadResp11, _sessionState$aadResp12, _sessionState$aadResp13, _sessionState$aadResp14, _sessionState$aadResp15, _sessionState$aadResp16, _sessionState$aadResp17;

      var sessionState, _res$loyalty13, _res$loyalty13$custom, res, result, token, email, url;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              // Getting storage form session since there is an issue when multiple components are using the same redux store
              sessionState = getSessionStorageKey("account"); // storybook mock

              if (!(window.location.href.indexOf("localhost:9009") > -1)) {
                _context8.next = 5;
                break;
              }

              res = pegPointsModuleResponse;
              result = (_res$loyalty13 = res.loyalty) === null || _res$loyalty13 === void 0 ? void 0 : (_res$loyalty13$custom = _res$loyalty13.customers) === null || _res$loyalty13$custom === void 0 ? void 0 : _res$loyalty13$custom.points;
              return _context8.abrupt("return", Promise.resolve(result || 0));

            case 5:
              token = sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp11 = sessionState.aadResponse) === null || _sessionState$aadResp11 === void 0 ? void 0 : _sessionState$aadResp11.jwtIdToken;

              if (token) {
                _context8.next = 8;
                break;
              }

              return _context8.abrupt("return", Promise.resolve(0));

            case 8:
              email = (sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp12 = sessionState.aadResponse) === null || _sessionState$aadResp12 === void 0 ? void 0 : (_sessionState$aadResp13 = _sessionState$aadResp12.account) === null || _sessionState$aadResp13 === void 0 ? void 0 : (_sessionState$aadResp14 = _sessionState$aadResp13.idToken) === null || _sessionState$aadResp14 === void 0 ? void 0 : _sessionState$aadResp14.email) || (sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp15 = sessionState.aadResponse) === null || _sessionState$aadResp15 === void 0 ? void 0 : (_sessionState$aadResp16 = _sessionState$aadResp15.account) === null || _sessionState$aadResp16 === void 0 ? void 0 : (_sessionState$aadResp17 = _sessionState$aadResp16.idToken) === null || _sessionState$aadResp17 === void 0 ? void 0 : _sessionState$aadResp17.signInName);

              if (email) {
                _context8.next = 11;
                break;
              }

              return _context8.abrupt("return", Promise.resolve(0));

            case 11:
              url = apiUtil.API.loyalty.getPegPointsModuleAuth.replace('{email}', email);
              return _context8.abrupt("return", UTIL.apiUtil.fetchPost(url, data, token).then(function (res) {
                if (res) {
                  var _res$loyalty14, _res$loyalty14$custom;

                  var _result4 = res === null || res === void 0 ? void 0 : (_res$loyalty14 = res.loyalty) === null || _res$loyalty14 === void 0 ? void 0 : (_res$loyalty14$custom = _res$loyalty14.customers) === null || _res$loyalty14$custom === void 0 ? void 0 : _res$loyalty14$custom.points;

                  return _result4 || 0;
                } else {
                  return 0;
                }
              }).catch(function (err) {
                console.error("Error on Peg Points Module Auth request: ", err);
                dispatch(receiveError(UTIL.buildError(err)));
                return 0;
              }));

            case 13:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref12.apply(this, arguments);
    };
  }();
}

function getOrderPegPoints(state, data) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch) {
      var _sessionState$aadResp18, _sessionState$aadResp19, _sessionState$aadResp20, _sessionState$aadResp21, _sessionState$aadResp22, _sessionState$aadResp23, _sessionState$aadResp24;

      var sessionState, _res$loyalty15, _res$loyalty15$custom, _res$loyalty15$custom2, res, order, token, email, url;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              // Getting storage form session since there is an issue when multiple components are using the same redux store
              sessionState = getSessionStorageKey("account"); // storybook mock

              if (!(window.location.href.indexOf("localhost:9009") > -1)) {
                _context9.next = 5;
                break;
              }

              res = getOrderPegPointsResponse;
              order = (_res$loyalty15 = res.loyalty) === null || _res$loyalty15 === void 0 ? void 0 : (_res$loyalty15$custom = _res$loyalty15.customers) === null || _res$loyalty15$custom === void 0 ? void 0 : (_res$loyalty15$custom2 = _res$loyalty15$custom.events) === null || _res$loyalty15$custom2 === void 0 ? void 0 : _res$loyalty15$custom2.find(function (event) {
                var _event$eventAttribute;

                return ((_event$eventAttribute = event.eventAttributes) === null || _event$eventAttribute === void 0 ? void 0 : _event$eventAttribute.onlineOrderNumber) === (data === null || data === void 0 ? void 0 : data.orderNumber);
              });
              return _context9.abrupt("return", Promise.resolve((order === null || order === void 0 ? void 0 : order.points) || 0));

            case 5:
              token = sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp18 = sessionState.aadResponse) === null || _sessionState$aadResp18 === void 0 ? void 0 : _sessionState$aadResp18.jwtIdToken;

              if (token) {
                _context9.next = 8;
                break;
              }

              return _context9.abrupt("return", Promise.resolve(0));

            case 8:
              email = (sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp19 = sessionState.aadResponse) === null || _sessionState$aadResp19 === void 0 ? void 0 : (_sessionState$aadResp20 = _sessionState$aadResp19.account) === null || _sessionState$aadResp20 === void 0 ? void 0 : (_sessionState$aadResp21 = _sessionState$aadResp20.idToken) === null || _sessionState$aadResp21 === void 0 ? void 0 : _sessionState$aadResp21.email) || (sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp22 = sessionState.aadResponse) === null || _sessionState$aadResp22 === void 0 ? void 0 : (_sessionState$aadResp23 = _sessionState$aadResp22.account) === null || _sessionState$aadResp23 === void 0 ? void 0 : (_sessionState$aadResp24 = _sessionState$aadResp23.idToken) === null || _sessionState$aadResp24 === void 0 ? void 0 : _sessionState$aadResp24.signInName);

              if (email) {
                _context9.next = 11;
                break;
              }

              return _context9.abrupt("return", Promise.resolve(0));

            case 11:
              url = apiUtil.API.loyalty.getOrderPegPoints.replace('{email}', email);
              return _context9.abrupt("return", UTIL.apiUtil.fetchGet(url, token).then(function (res) {
                if (res) {
                  var _res$loyalty16, _res$loyalty16$custom, _res$loyalty16$custom2;

                  var _order = (_res$loyalty16 = res.loyalty) === null || _res$loyalty16 === void 0 ? void 0 : (_res$loyalty16$custom = _res$loyalty16.customers) === null || _res$loyalty16$custom === void 0 ? void 0 : (_res$loyalty16$custom2 = _res$loyalty16$custom.events) === null || _res$loyalty16$custom2 === void 0 ? void 0 : _res$loyalty16$custom2.find(function (event) {
                    var _event$eventAttribute2;

                    return ((_event$eventAttribute2 = event.eventAttributes) === null || _event$eventAttribute2 === void 0 ? void 0 : _event$eventAttribute2.onlineOrderNumber) === (data === null || data === void 0 ? void 0 : data.orderNumber);
                  });

                  return (_order === null || _order === void 0 ? void 0 : _order.points) || 0;
                } else {
                  return 0;
                }
              }).catch(function (err) {
                console.error('Error on Events Purchase request: ', err);
                dispatch(receiveError(UTIL.buildError(err)));
                return 0;
              }));

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref13.apply(this, arguments);
    };
  }();
}

function rewardsRedemption(state, bonusRewards, pegPoints) {
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var action = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dispatch) {
      var _state$account4, _state$account4$aadRe, _state$account4$aadRe2, _state$account4$aadRe3, _state$account5, _state$account5$aadRe, _state$account5$aadRe2, _state$account5$aadRe3, _state$account6, _state$account6$aadRe;

      var email, token, rewardsRedemptionRequest, cart, _state$rewards, _state$rewards2, _state$rewards2$lastC, _state$rewards3, _state$rewards3$lastC, _lastCartSent$sort, _state$rewards4, _state$rewards4$custo, _state$rewards4$custo2, _state$rewards4$custo3, _state$rewards4$custo4, _state$cart, _state$cart$cartBefor, _state$cart$cartBefor2, _state$cart$cartBefor3, lastCartSent, lastCartUpdated, oldItemDeletedFlag, rewardedItems, itemDeletedFlag, newCart, _state$cart2, _state$cart2$cartBefo, _state$cart2$cartBefo2, _state$cart2$cartBefo3, url;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              email = ((_state$account4 = state.account) === null || _state$account4 === void 0 ? void 0 : (_state$account4$aadRe = _state$account4.aadResponse) === null || _state$account4$aadRe === void 0 ? void 0 : (_state$account4$aadRe2 = _state$account4$aadRe.account) === null || _state$account4$aadRe2 === void 0 ? void 0 : (_state$account4$aadRe3 = _state$account4$aadRe2.idToken) === null || _state$account4$aadRe3 === void 0 ? void 0 : _state$account4$aadRe3.email) || ((_state$account5 = state.account) === null || _state$account5 === void 0 ? void 0 : (_state$account5$aadRe = _state$account5.aadResponse) === null || _state$account5$aadRe === void 0 ? void 0 : (_state$account5$aadRe2 = _state$account5$aadRe.account) === null || _state$account5$aadRe2 === void 0 ? void 0 : (_state$account5$aadRe3 = _state$account5$aadRe2.idToken) === null || _state$account5$aadRe3 === void 0 ? void 0 : _state$account5$aadRe3.signInName);
              token = (_state$account6 = state.account) === null || _state$account6 === void 0 ? void 0 : (_state$account6$aadRe = _state$account6.aadResponse) === null || _state$account6$aadRe === void 0 ? void 0 : _state$account6$aadRe.jwtIdToken; // storybook mock

              if (!(window.location.href.indexOf('localhost:9009') > -1)) {
                _context10.next = 6;
                break;
              }

              return _context10.abrupt("return", new Promise(function (resolve) {
                return setTimeout(function () {
                  return resolve({});
                }, 2000);
              }).then(function () {
                switch (type) {
                  case 'recommended':
                    dispatch(getRewardsRedemptionAction(rewardsRedemptionResponse));
                    return rewardsRedemptionResponse || {};

                  case 'custom':
                    dispatch(getCustomRewardsRedemptionAction(customRewardsRedemptionResponse));
                    return customRewardsRedemptionResponse || {};

                  case 'update-custom':
                    dispatch(getCustomRewardsRedemptionAction(customRewardsRedemptionResponse));
                    return customRewardsRedemptionResponse || {};

                  default:
                    return customRewardsRedemptionResponse || {};
                }
              }));

            case 6:
              if (token) {
                _context10.next = 8;
                break;
              }

              return _context10.abrupt("return", Promise.resolve({}));

            case 8:
              rewardsRedemptionRequest = {
                "needMD5": true,
                "email": email,
                "redeemOptions": [{
                  "pointsToRedeem": pegPoints.toString() || "0",
                  "bonusRewardsToRedeem": bonusRewards.map(function (reward) {
                    return {
                      "rewardId": reward
                    };
                  })
                }]
              };
              cart = [];

              if (type === 'update-custom') {
                if ((_state$rewards = state.rewards) === null || _state$rewards === void 0 ? void 0 : _state$rewards.lastCustomRewardsRequest) {
                  rewardsRedemptionRequest.redeemOptions = (_state$rewards2 = state.rewards) === null || _state$rewards2 === void 0 ? void 0 : (_state$rewards2$lastC = _state$rewards2.lastCustomRewardsRequest) === null || _state$rewards2$lastC === void 0 ? void 0 : _state$rewards2$lastC.redeemOptions;
                  lastCartSent = (_state$rewards3 = state.rewards) === null || _state$rewards3 === void 0 ? void 0 : (_state$rewards3$lastC = _state$rewards3.lastCustomRewardsRequest) === null || _state$rewards3$lastC === void 0 ? void 0 : _state$rewards3$lastC.cart;
                  lastCartUpdated = [];
                  oldItemDeletedFlag = false;
                  lastCartSent === null || lastCartSent === void 0 ? void 0 : (_lastCartSent$sort = lastCartSent.sort(function (a, b) {
                    return a.cartLineItem - b.cartLineItem;
                  })) === null || _lastCartSent$sort === void 0 ? void 0 : _lastCartSent$sort.forEach(function (item) {
                    if (action === 'delete' && state.rewards.lastRemovedItem) {
                      if (state.rewards.lastRemovedItem === "".concat(item.productChainId, "-").concat(item.cartLineItem)) {
                        oldItemDeletedFlag = true;
                      } else if (!oldItemDeletedFlag) {
                        var _state$rewards$lastRe;

                        var splitLastRemovedItem = (_state$rewards$lastRe = state.rewards.lastRemovedItem) === null || _state$rewards$lastRe === void 0 ? void 0 : _state$rewards$lastRe.split('-');

                        if (parseInt(splitLastRemovedItem === null || splitLastRemovedItem === void 0 ? void 0 : splitLastRemovedItem[1]) < parseInt(item.cartLineItem)) {
                          oldItemDeletedFlag = true;
                        }
                      }
                    }

                    if (oldItemDeletedFlag) {
                      lastCartUpdated.push(_objectSpread(_objectSpread({}, item), {}, {
                        cartLineItem: (parseInt(item.cartLineItem) - 1).toString()
                      }));
                    } else {
                      lastCartUpdated.push(item);
                    }
                  });
                  rewardedItems = [];
                  itemDeletedFlag = false;
                  (_state$rewards4 = state.rewards) === null || _state$rewards4 === void 0 ? void 0 : (_state$rewards4$custo = _state$rewards4.customRewardsRedemptionResponse) === null || _state$rewards4$custo === void 0 ? void 0 : (_state$rewards4$custo2 = _state$rewards4$custo.redeemOptions) === null || _state$rewards4$custo2 === void 0 ? void 0 : (_state$rewards4$custo3 = _state$rewards4$custo2[0].cart) === null || _state$rewards4$custo3 === void 0 ? void 0 : (_state$rewards4$custo4 = _state$rewards4$custo3.sort(function (a, b) {
                    return a.cartLineItem - b.cartLineItem;
                  })) === null || _state$rewards4$custo4 === void 0 ? void 0 : _state$rewards4$custo4.forEach(function (item) {
                    if (action === 'delete' && state.rewards.lastRemovedItem) {
                      if (state.rewards.lastRemovedItem === "".concat(item.productChainId, "-").concat(item.cartLineItem)) {
                        itemDeletedFlag = true;

                        if (item.redemptionType === 'points') {
                          rewardsRedemptionRequest.redeemOptions[0].pointsToRedeem = (parseInt(rewardsRedemptionRequest.redeemOptions[0].pointsToRedeem) - parseInt(item.pointsRedeemed)).toString();
                        } else {
                          var _item$bonusRewardAppl, _item$bonusRewardAppl2;

                          if ((_item$bonusRewardAppl = item.bonusRewardAppliedId) === null || _item$bonusRewardAppl === void 0 ? void 0 : (_item$bonusRewardAppl2 = _item$bonusRewardAppl[0]) === null || _item$bonusRewardAppl2 === void 0 ? void 0 : _item$bonusRewardAppl2.bonusRewardId) {
                            rewardsRedemptionRequest.redeemOptions[0].bonusRewardsToRedeem = rewardsRedemptionRequest.redeemOptions[0].bonusRewardsToRedeem.filter(function (reward) {
                              var _item$bonusRewardAppl3, _item$bonusRewardAppl4;

                              return reward.rewardId !== ((_item$bonusRewardAppl3 = item.bonusRewardAppliedId) === null || _item$bonusRewardAppl3 === void 0 ? void 0 : (_item$bonusRewardAppl4 = _item$bonusRewardAppl3[0]) === null || _item$bonusRewardAppl4 === void 0 ? void 0 : _item$bonusRewardAppl4.bonusRewardId);
                            });
                          }
                        }
                      } else if (!itemDeletedFlag) {
                        var _state$rewards$lastRe2;

                        var splitLastRemovedItem = (_state$rewards$lastRe2 = state.rewards.lastRemovedItem) === null || _state$rewards$lastRe2 === void 0 ? void 0 : _state$rewards$lastRe2.split('-');

                        if (parseInt(splitLastRemovedItem === null || splitLastRemovedItem === void 0 ? void 0 : splitLastRemovedItem[1]) < parseInt(item.cartLineItem)) {
                          itemDeletedFlag = true;
                        }
                      }
                    }

                    if (itemDeletedFlag) {
                      if (!rewardedItems.includes("".concat(item.productChainId, "-").concat(parseInt(item.cartLineItem) - 1))) {
                        rewardedItems.push("".concat(item.productChainId, "-").concat((parseInt(item.cartLineItem) - 1).toString()));
                      }
                    } else {
                      if (!rewardedItems.includes("".concat(item.productChainId, "-").concat(item.cartLineItem))) {
                        rewardedItems.push("".concat(item.productChainId, "-").concat(item.cartLineItem));
                      }
                    }
                  });
                  newCart = (_state$cart = state.cart) === null || _state$cart === void 0 ? void 0 : (_state$cart$cartBefor = _state$cart.cartBeforeRewards) === null || _state$cart$cartBefor === void 0 ? void 0 : (_state$cart$cartBefor2 = _state$cart$cartBefor.cart_org) === null || _state$cart$cartBefor2 === void 0 ? void 0 : (_state$cart$cartBefor3 = _state$cart$cartBefor2.filter(function (item) {
                    return item.Product.CatalogName === 'CB_Food_Store';
                  })) === null || _state$cart$cartBefor3 === void 0 ? void 0 : _state$cart$cartBefor3.map(function (item, index) {
                    return {
                      "productChainId": item.Product.ProductChainId,
                      "posId": "",
                      "quantity": item.Quantity,
                      "amount": "".concat(item.Price.Subtotal),
                      "cartLineItem": "".concat(index + 1)
                    };
                  });

                  if (rewardedItems.length) {
                    newCart.forEach(function (item) {
                      if (rewardedItems.includes("".concat(item.productChainId, "-").concat(item.cartLineItem))) {
                        var oldItemSent = lastCartUpdated.find(function (oldItem) {
                          return oldItem.productChainId === item.productChainId && oldItem.cartLineItem === item.cartLineItem;
                        });

                        if (oldItemSent) {
                          if (oldItemSent.quantity > item.quantity) {
                            cart.push(item);
                          } else {
                            cart.push(oldItemSent);
                          }
                        }
                      }
                    });
                  }
                }
              } else {
                cart = (_state$cart2 = state.cart) === null || _state$cart2 === void 0 ? void 0 : (_state$cart2$cartBefo = _state$cart2.cartBeforeRewards) === null || _state$cart2$cartBefo === void 0 ? void 0 : (_state$cart2$cartBefo2 = _state$cart2$cartBefo.cart_org) === null || _state$cart2$cartBefo2 === void 0 ? void 0 : (_state$cart2$cartBefo3 = _state$cart2$cartBefo2.filter(function (item) {
                  return item.Product.CatalogName === 'CB_Food_Store';
                })) === null || _state$cart2$cartBefo3 === void 0 ? void 0 : _state$cart2$cartBefo3.map(function (item, index) {
                  return {
                    "productChainId": item.Product.ProductChainId,
                    "posId": "",
                    "quantity": item.Quantity,
                    "amount": "".concat(item.Price.Subtotal),
                    "cartLineItem": "".concat(index + 1)
                  };
                });
              }

              rewardsRedemptionRequest.cart = cart;

              if (type === 'custom' || type === 'update-custom') {
                dispatch(storeLastCustomRewardsRequest(rewardsRedemptionRequest));
              }

              url = apiUtil.API.loyalty.postRewardsRedemption;
              return _context10.abrupt("return", UTIL.apiUtil.fetchPost(url, rewardsRedemptionRequest, token).then(function (response) {
                switch (type) {
                  case 'recommended':
                    dispatch(getRewardsRedemptionAction(response));
                    return response || {};

                  case 'custom':
                  case 'update-custom':
                    dispatch(getCustomRewardsRedemptionAction(response));
                    return response || {};

                  default:
                    return response || {};
                }
              }).catch(function (err) {
                console.error('Error on Rewards Redemption Engine request: ', err);
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 15:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref14.apply(this, arguments);
    };
  }();
}

function redeemRewards(state, type) {
  return /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(dispatch) {
      var _rewardsResponse, _rewardsResponse$rede;

      var rewards, cart, rewardsResponse, _rewardsResponse$rede2, _cart$cartBeforeRewar, _cart$cartBeforeRewar2, _cart$cartBeforeRewar3, _rewardsAndCoupons, _rewardsAndCoupons$pe, _rewardsAndCoupons2, _rewardsAndCoupons2$c, _LoyaltyRewardIDs, _LoyaltyCouponCodes, _rewardsResponse2, _rewardsResponse2$red, cartItemsWithRewardDiscounts, cartItemsWithPointsDiscounts, bonusRewards, pegs, totalDiscountAmount, rewardsAndCoupons, LoyaltyRewardIDs, pegReward, LoyaltyCouponCodes, availableCoupons, couponsCodes, checkout;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              rewards = state.rewards, cart = state.cart;
              _context11.t0 = type;
              _context11.next = _context11.t0 === 'recommended' ? 4 : _context11.t0 === 'custom' ? 6 : 8;
              break;

            case 4:
              rewardsResponse = rewards === null || rewards === void 0 ? void 0 : rewards.rewardsRedemptionResponse;
              return _context11.abrupt("break", 8);

            case 6:
              rewardsResponse = rewards === null || rewards === void 0 ? void 0 : rewards.customRewardsRedemptionResponse;
              return _context11.abrupt("break", 8);

            case 8:
              if (!(((_rewardsResponse = rewardsResponse) === null || _rewardsResponse === void 0 ? void 0 : (_rewardsResponse$rede = _rewardsResponse.redeemOptions) === null || _rewardsResponse$rede === void 0 ? void 0 : _rewardsResponse$rede.length) > 0)) {
                _context11.next = 36;
                break;
              }

              cartItemsWithRewardDiscounts = [];
              cartItemsWithPointsDiscounts = [];
              (_rewardsResponse$rede2 = rewardsResponse.redeemOptions[0].cart) === null || _rewardsResponse$rede2 === void 0 ? void 0 : _rewardsResponse$rede2.forEach(function (item) {
                if (item.redemptionType === "rewards") {
                  if ("".concat(item.productChainId, "-").concat(item.cartLineItem) in cartItemsWithRewardDiscounts) {
                    cartItemsWithRewardDiscounts["".concat(item.productChainId, "-").concat(item.cartLineItem)].push(item);
                  } else {
                    cartItemsWithRewardDiscounts["".concat(item.productChainId, "-").concat(item.cartLineItem)] = [item];
                  }
                } else {
                  if ("".concat(item.productChainId, "-").concat(item.cartLineItem) in cartItemsWithPointsDiscounts) {
                    cartItemsWithPointsDiscounts["".concat(item.productChainId, "-").concat(item.cartLineItem)].push(item);
                  } else {
                    cartItemsWithPointsDiscounts["".concat(item.productChainId, "-").concat(item.cartLineItem)] = [item];
                  }
                }
              });
              bonusRewards = [];
              pegs = 0;
              totalDiscountAmount = 0;
              cart === null || cart === void 0 ? void 0 : (_cart$cartBeforeRewar = cart.cartBeforeRewards) === null || _cart$cartBeforeRewar === void 0 ? void 0 : (_cart$cartBeforeRewar2 = _cart$cartBeforeRewar.cart_org) === null || _cart$cartBeforeRewar2 === void 0 ? void 0 : (_cart$cartBeforeRewar3 = _cart$cartBeforeRewar2.filter(function (item) {
                return item.Product.CatalogName === 'CB_Food_Store';
              })) === null || _cart$cartBeforeRewar3 === void 0 ? void 0 : _cart$cartBeforeRewar3.forEach(function (cartItem, index) {
                if ("".concat(cartItem.Product.ProductChainId, "-").concat(index + 1) in cartItemsWithRewardDiscounts) {
                  cartItemsWithRewardDiscounts["".concat(cartItem.Product.ProductChainId, "-").concat(index + 1)].forEach(function (item) {
                    var _item$bonusRewardAppl5, _item$bonusRewardAppl6;

                    var reward = (item === null || item === void 0 ? void 0 : (_item$bonusRewardAppl5 = item.bonusRewardAppliedId) === null || _item$bonusRewardAppl5 === void 0 ? void 0 : (_item$bonusRewardAppl6 = _item$bonusRewardAppl5[0]) === null || _item$bonusRewardAppl6 === void 0 ? void 0 : _item$bonusRewardAppl6.bonusRewardId) || null;

                    if (reward) {
                      bonusRewards.push({
                        id: reward
                      });
                      var discountAmount = (item === null || item === void 0 ? void 0 : item.amount) || 0;
                      totalDiscountAmount += discountAmount;
                    }
                  });
                }

                if ("".concat(cartItem.Product.ProductChainId, "-").concat(index + 1) in cartItemsWithPointsDiscounts) {
                  cartItemsWithPointsDiscounts["".concat(cartItem.Product.ProductChainId, "-").concat(index + 1)].forEach(function (item) {
                    var pointsRedeemed = (item === null || item === void 0 ? void 0 : item.pointsRedeemed) || 0;

                    if (pointsRedeemed) {
                      pegs += pointsRedeemed;
                      var discountAmount = (item === null || item === void 0 ? void 0 : item.amount) || 0;
                      totalDiscountAmount += discountAmount;
                    }
                  });
                }
              });
              rewardsAndCoupons = {
                coupons: [],
                pegRewards: []
              };
              _context11.prev = 17;
              _context11.next = 20;
              return dispatch(getRewardsAndCoupons(state));

            case 20:
              rewardsAndCoupons = _context11.sent;
              _context11.next = 26;
              break;

            case 23:
              _context11.prev = 23;
              _context11.t1 = _context11["catch"](17);
              console.error('Error on Rewards And Coupons request: ', _context11.t1);

            case 26:
              LoyaltyRewardIDs = [];

              if (pegs && pegs !== '0' && ((_rewardsAndCoupons = rewardsAndCoupons) === null || _rewardsAndCoupons === void 0 ? void 0 : (_rewardsAndCoupons$pe = _rewardsAndCoupons.pegRewards) === null || _rewardsAndCoupons$pe === void 0 ? void 0 : _rewardsAndCoupons$pe.length)) {
                pegReward = rewardsAndCoupons.pegRewards.find(function (reward) {
                  return parseInt(reward.points) === parseInt(pegs);
                });
                LoyaltyRewardIDs = (pegReward === null || pegReward === void 0 ? void 0 : pegReward.id) ? [pegReward.id] : null;
              }

              LoyaltyCouponCodes = [];

              if ((bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.length) > 0 && ((_rewardsAndCoupons2 = rewardsAndCoupons) === null || _rewardsAndCoupons2 === void 0 ? void 0 : (_rewardsAndCoupons2$c = _rewardsAndCoupons2.coupons) === null || _rewardsAndCoupons2$c === void 0 ? void 0 : _rewardsAndCoupons2$c.length)) {
                availableCoupons = rewardsAndCoupons.coupons;
                couponsCodes = [];
                bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.forEach(function (bonusReward, index) {
                  for (var i = 0; i < (availableCoupons === null || availableCoupons === void 0 ? void 0 : availableCoupons.length); i++) {
                    if (availableCoupons[i].external_id === bonusReward.id) {
                      couponsCodes.push(availableCoupons[i].code);
                      bonusRewards[index] = _objectSpread(_objectSpread({}, bonusRewards[index]), {}, {
                        code: availableCoupons[i].code
                      });
                      availableCoupons.splice(i, 1);
                      break;
                    }
                  }
                });
                LoyaltyCouponCodes = (couponsCodes === null || couponsCodes === void 0 ? void 0 : couponsCodes.length) ? couponsCodes : null;
              }

              checkout = {
                LoyaltyRewardIDs: ((_LoyaltyRewardIDs = LoyaltyRewardIDs) === null || _LoyaltyRewardIDs === void 0 ? void 0 : _LoyaltyRewardIDs.length) ? LoyaltyRewardIDs : null,
                LoyaltyCouponCodes: ((_LoyaltyCouponCodes = LoyaltyCouponCodes) === null || _LoyaltyCouponCodes === void 0 ? void 0 : _LoyaltyCouponCodes.length) ? LoyaltyCouponCodes : null,
                LoyaltyDiscount: totalDiscountAmount ? parseFloat(totalDiscountAmount).toFixed(2) : null,
                LoyaltyValidationText: ((_rewardsResponse2 = rewardsResponse) === null || _rewardsResponse2 === void 0 ? void 0 : (_rewardsResponse2$red = _rewardsResponse2.redeemOptions[0]) === null || _rewardsResponse2$red === void 0 ? void 0 : _rewardsResponse2$red.validationText) || null
              };

              if (!(pegs && pegs !== '0' || (bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.length) > 0)) {
                _context11.next = 35;
                break;
              }

              return _context11.abrupt("return", {
                pegs: pegs,
                rewards: bonusRewards,
                totalDiscountAmount: parseFloat(totalDiscountAmount).toFixed(2),
                type: type,
                checkout: checkout,
                foodBasketId: cart === null || cart === void 0 ? void 0 : cart.foodBasketId
              });

            case 35:
              return _context11.abrupt("return", null);

            case 36:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[17, 23]]);
    }));

    return function (_x11) {
      return _ref15.apply(this, arguments);
    };
  }();
}

var handleGetPegPoints = function handleGetPegPoints(email) {
  return /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", dispatch(getPegPoints(getState(), email)));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x12, _x13) {
      return _ref16.apply(this, arguments);
    };
  }();
};

var handleResetPegPoints = function handleResetPegPoints() {
  return function (dispatch, getState) {
    return dispatch(resetPegPoints(getState()));
  };
};

var handleGetBonusRewards = function handleGetBonusRewards() {
  return /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", dispatch(getBonusRewards(getState())));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x14, _x15) {
      return _ref17.apply(this, arguments);
    };
  }();
};

var handleGetBonusRewardsAccountInfo = function handleGetBonusRewardsAccountInfo(accountInfo) {
  return /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", dispatch(getBonusRewardsAccountInfo(getState(), accountInfo)));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function (_x16, _x17) {
      return _ref18.apply(this, arguments);
    };
  }();
};

var handleGetMenuItemPegPoints = function handleGetMenuItemPegPoints(productId) {
  return /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", dispatch(getMenuItemPegPoints(getState(), productId)));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x18, _x19) {
      return _ref19.apply(this, arguments);
    };
  }();
};

var handleGetPegPointsModule = function handleGetPegPointsModule(data) {
  return /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", dispatch(getPegPointsModule(getState(), data)));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function (_x20, _x21) {
      return _ref20.apply(this, arguments);
    };
  }();
};

var handleGetPegPointsModuleAuth = function handleGetPegPointsModuleAuth(data) {
  return /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", dispatch(getPegPointsModuleAuth(getState(), data)));

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function (_x22, _x23) {
      return _ref21.apply(this, arguments);
    };
  }();
};

var handleGetOrderPegPoints = function handleGetOrderPegPoints(data) {
  return /*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", dispatch(getOrderPegPoints(getState(), data)));

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    return function (_x24, _x25) {
      return _ref22.apply(this, arguments);
    };
  }();
};

var handleRewardsRedemption = function handleRewardsRedemption(bonusRewards, pegPoints, type, action) {
  return /*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", dispatch(rewardsRedemption(getState(), bonusRewards, pegPoints, type, action)));

            case 1:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    return function (_x26, _x27) {
      return _ref23.apply(this, arguments);
    };
  }();
};

var handleRedeemRewards = function handleRedeemRewards(type) {
  return /*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", dispatch(redeemRewards(getState(), type)));

            case 1:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    return function (_x28, _x29) {
      return _ref24.apply(this, arguments);
    };
  }();
};

var handleSetLocalPegPoints = function handleSetLocalPegPoints(points) {
  return /*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt("return", dispatch(setLocalPegPoints(getState(), points)));

            case 1:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }));

    return function (_x30, _x31) {
      return _ref25.apply(this, arguments);
    };
  }();
};

export default {
  handleGetPegPoints: handleGetPegPoints,
  handleGetBonusRewards: handleGetBonusRewards,
  handleGetBonusRewardsAccountInfo: handleGetBonusRewardsAccountInfo,
  handleGetPegPointsModule: handleGetPegPointsModule,
  handleResetPegPoints: handleResetPegPoints,
  handleGetMenuItemPegPoints: handleGetMenuItemPegPoints,
  handleRewardsRedemption: handleRewardsRedemption,
  handleRedeemRewards: handleRedeemRewards,
  handleSetLocalPegPoints: handleSetLocalPegPoints,
  resetRewardsRedemptionAction: resetRewardsRedemptionAction,
  resetRewardsRedemptionModule: resetRewardsRedemptionModule,
  redeemRewardsAction: redeemRewardsAction,
  storeLastRemovedItem: storeLastRemovedItem,
  processingRewards: processingRewards,
  handleGetPegPointsModuleAuth: handleGetPegPointsModuleAuth,
  handleGetOrderPegPoints: handleGetOrderPegPoints
};